import { render } from "./OnlyFooter.vue?vue&type=template&id=a732f39c&scoped=true"
import script from "./OnlyFooter.vue?vue&type=script&lang=js"
export * from "./OnlyFooter.vue?vue&type=script&lang=js"

import "./OnlyFooter.vue?vue&type=style&index=0&id=a732f39c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a732f39c"]])

export default __exports__